import * as React from 'react'

import { Box, Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import {
  CompanyEstimateManagerScoreFragment,
  PerformanceSetShowEstimatedScoreDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type Props = {
  companySetting: CompanyEstimateManagerScoreFragment
}

export const CompanyEstimateManagerScore: React.FC<Props> = ({ companySetting }) => {
  const [localShowEstimatedScore, setLocalShowEstimatedScore] = React.useState(
    companySetting.showEstimatedScore
  )

  const [updateShowEstimatedScore, { loading }] = useMutation(
    PerformanceSetShowEstimatedScoreDocument,
    {
      extractorFn: (data) =>
        data.performanceMutations.setShowEstimatedScorePerformanceCompanySetting,
    }
  )

  const handleChange = async (value: boolean) => {
    const response = await updateShowEstimatedScore({
      variables: {
        id: companySetting.id,
        showEstimatedScore: value,
      },
    })

    const result = handleResult(response, () => {})

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    } else {
      setLocalShowEstimatedScore(!value)
    }
  }

  return (
    <Box gap="s32">
      <Card>
        <Card.Title
          size="medium"
          action={
            <TogglerCheckbox
              value={localShowEstimatedScore}
              onChange={(value) => handleChange(value)}
              disabled={loading}
              aria-label={i18n.t(
                'performance_process.employee_score.company_settings.dynamic_scoring.toggle_label'
              )}
            />
          }
        >
          {i18n.t(
            'performance_process.employee_score.company_settings.dynamic_scoring.toggle_label'
          )}
        </Card.Title>
        <Card.Description>
          {i18n.t(
            'performance_process.employee_score.company_settings.dynamic_scoring.description'
          )}
        </Card.Description>
      </Card>
    </Box>
  )
}
